import React from 'react';
import { Result } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

export default function PermissionDenied() {
  return (
    <Result icon={<ExclamationCircleOutlined />} title="403" subTitle="沒有訪問此頁面的權限噢！" />
  );
}
